import React, { useState } from 'react';
import Icon from './Icon';

/**
 * دکمه‌ی دانلود خروجی اکسل.
 * onExport باید یک پاسخ axios با responseType: 'blob' برگرداند.
 */
export default function ExportButton({ onExport, fileName = 'export.xlsx', label = 'خروجی اکسل' }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleClick = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await onExport();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      setError('دریافت فایل ناموفق بود');
      setTimeout(() => setError(''), 4000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <span className="inline-flex items-center gap-2">
      <button
        type="button"
        onClick={handleClick}
        disabled={loading}
        className="inline-flex h-11 items-center gap-2 rounded-xl border border-emerald-200 bg-emerald-50 px-4 text-sm font-bold text-emerald-700 transition hover:bg-emerald-100 disabled:pointer-events-none disabled:opacity-60"
      >
        <Icon name="document" className="h-4 w-4" />
        {loading ? 'در حال ساخت فایل...' : label}
      </button>
      {error && <span className="text-xs font-bold text-red-500">{error}</span>}
    </span>
  );
}
